"use client";

import {useEffect, useState} from 'react';

export function useIsMobile(breakpoint = 768) {
    const [isMobile, setIsMobile] = useState(true); // default to true initially

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(window.innerWidth < breakpoint);

        checkIsMobile(); // check immediately after mount
        window.addEventListener('resize', checkIsMobile);

        return () => window.removeEventListener('resize', checkIsMobile);
    }, [breakpoint]);

    return isMobile;
}